const projects = [
                  {
                    title: "Airbnb",
                    projID:"Airbnb",
                    description:"This app lets you to search for rental homes in various places and book homes at the desired cost.",
                    githubLink:"https://github.com/SwethaMuralidharan/Airbnb-FrontEnd",
                    logoSrc:"./images/Airbnb_1.png",
                    deployedLink : "https://airbnb-fe.herokuapp.com/",
                    tech:"MERN Stack"
                  },
                  {
                    title : "Lovely",
                    projID:"Lovely",
                    description:"A dating app gets what it really takes to sustain a long lasting relationship: shared values.",
                    githubLink:"https://github.com/SwethaMuralidharan/Lovely-A-Dating-App-Frontend",
                    logoSrc:"./images/Lovely_1.png",
                    deployedLink : "https://shrouded-crag-90176.herokuapp.com/",
                    tech:"MERN Stack"
                  },
                  {
                    title: "Tic Tac Toe",
                    projID:"Tic Tac Toe",
                    description:"This app lets you to play tic tac toe game.",
                    githubLink:"https://github.com/SwethaMuralidharan/React-Game",
                    logoSrc:"./images/tic-tac-toe.png",
                    deployedLink : "https://swetha-ttt.herokuapp.com/",
                    tech:"React.js"
                  },
                  {
                    title : "Foogle",
                    projID : "Foogle",
                    description: "Users can add and search through a list of restaurants and also add reviews.",
                    githubLink : "https://github.com/SwethaMuralidharan/Foogle",
                    logoSrc:"./images/Foogle_1.png",
                    deployedLink : "https://fast-anchorage-49388.herokuapp.com/",
                    tech:"Node.js"
                   },
                   {
                    title:"Travagram",
                    projID:"Travagram",
                    description:"Site for users to view various reviews about cities people have visitied.",
                    githubLink:"https://github.com/SwethaMuralidharan/Project-2---Vagabond",
                    logoSrc:"./images/Travagram_1.png",
                    deployedLink : "https://secret-dawn-85607.herokuapp.com/",
                    tech:"Ruby On Rails"
                   },

];

export default projects;



/** WEBPACK FOOTER **
 ** ./src/helpers/projects.js
 **/